import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
    Aangifte, BokkzAlgDataService, IncomeTaxEntity, KostenGehandicaptKind, PGAWeekendUitgavenGehandicapteKinderen
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-pga-weekenduitgaven-gehandicapte-kinderen',
  templateUrl: './pga-weekenduitgaven-gehandicapte-kinderen.component.html',
  styleUrls: ['./pga-weekenduitgaven-gehandicapte-kinderen.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiAlertModule,
    CommonModule
  ]
})
export class PgaWeekenduitgavenGehandicapteKinderenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    private focusedElementId: string | null = null;

    public kostenGehandicaptKind = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.kostenGehandicaptKind = this.fb.group({
            pgaKostenGehandicaptKind:
                this.fb.array<PGAWeekendUitgavenGehandicapteKinderen>([])
        })
    }

    get pgaKostenGehandicaptKind(): FormArray {
        return this.kostenGehandicaptKind.get('pgaKostenGehandicaptKind') as FormArray;
    }

    addRijKostenGehandicaptKind(): void {
        this.pgaKostenGehandicaptKind.push(this.createKostenGehandicaptKindFormGroup()
        )
    }

    verwijderRijKostenGehandicaptKind(index: number): void {
        this.pgaKostenGehandicaptKind.removeAt(index);
        this.kostenGehandicaptKind.updateValueAndValidity()
        this.kostenGehandicaptKind.markAsDirty()
        this.saveForm()
    }

    createKostenGehandicaptKindFormGroup(kosten?: KostenGehandicaptKind) {
        return this.fb.group(({
                naam: kosten ? kosten.naam : undefined,
                geboortedatumKind: kosten ? kosten.geboortedatumKind : undefined,
                dagenVerzorging: kosten ? kosten.dagenVerzorging : undefined,
                dagenGereisd: kosten ? kosten.dagenGereisd : undefined,
                afstandEnkeleReis: kosten ? kosten.afstandEnkeleReis : undefined,
                vergoeding: kosten ? kosten.vergoeding : undefined
            } as KostenGehandicaptKind)
        )
    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
        this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

  private hasUnsavedChanges(): boolean {
    return this.kostenGehandicaptKind.dirty;
  }

  private updateForm(): void {
        const kostenGehandicaptKindLijst = this.aangifte?.persoonsgebondenAftrek?.pgaWeekendUitgavenGehandicapteKinderen?.kostenGehandicaptKind || [];
        const formArray = this.kostenGehandicaptKind.get('pgaKostenGehandicaptKind') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > kostenGehandicaptKindLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < kostenGehandicaptKindLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(kostenGehandicaptKindLijst[i]);
            } else {
                const formGroup = this.createKostenGehandicaptKindFormGroup(kostenGehandicaptKindLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                persoonsgebondenAftrek: {
                    ...this.aangifte.persoonsgebondenAftrek,
                    pgaWeekendUitgavenGehandicapteKinderen: {
                        ...this.aangifte.persoonsgebondenAftrek?.pgaWeekendUitgavenGehandicapteKinderen,
                        kostenGehandicaptKind: this.kostenGehandicaptKind.value.pgaKostenGehandicaptKind
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        }, 200)
    }

    hasKindJongerDan21(): boolean {
        return this.pgaKostenGehandicaptKind.controls.some(control => {
            const geboortedatum = control.get('geboortedatumKind')?.value; // Haal de geboortedatum op
            if (!geboortedatum) return false; // Als er geen geboortedatum is, retourneer false

            const geboorteJaar = new Date(geboortedatum).getFullYear(); // Extraheer het jaar uit de geboortedatum
            const aangifteJaar = this.aangifte.aangifteJaar; // Haal het aangiftejaar op
            return geboorteJaar > (aangifteJaar - 21); // Vergelijk alleen de jaren
        });
    }
}
